import React from "react";
import FadedRightImage from "../common/FadedRightImage";
import ContactUsImageSvg from "../../Icons/ContactUsImageSvg";

export default function TopFadedContactUsImage() {
  return (
    <FadedRightImage
      title="We would love to hear from you"
      description="It may be your queries, suggestions, feedback, or anything else. Write to us or call us anytime, and we are eager to listen to you!!! "
      image={<ContactUsImageSvg />}
    />
  );
}
